import React from 'react';
import { SectionProps } from '../types';
import SectionTitle from '../shared/SectionTitle';
import SectionMessage from '../shared/SectionMessage';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionTooltip from '../shared/SectionTooltip';
import HowToFix from '../shared/HowToFix';

export default function CanonicalTagsSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {result.canonical_tags && result.canonical_tags.length > 0 && (
                    <>
                        <div className={`result-meta ${result.status}`}>
                            {result.canonical_tags.map((tag: string, idx: number) => (
                                <div key={idx}>
                                    <em>{tag}</em>
                                </div>
                            ))}
                        </div>
                        {result.how_to_fix && (
                            <HowToFix
                                title={title}
                                howToFix={result.how_to_fix}
                                howToFixVideo={result.how_to_fix_video}
                            />
                        )}
                    </>
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}
